<template>
  <div class="breadBox">
    <a-breadcrumb>
      <span>
        <img src="@/assets/img/position.png"/>
        当前位置：
      </span>
      <a-breadcrumb-item @click="$router.push({ path: '/knowledge/index'})" style="cursor: pointer;">首页</a-breadcrumb-item>
      <a-breadcrumb-item @click="$router.push({ path: '/knowledge/investor/index'})" style="cursor: pointer;">知识产权交易</a-breadcrumb-item>
      <a-breadcrumb-item v-if="optionsData">{{optionsData.knowledgeCopyright.copyrightName}}</a-breadcrumb-item>
    </a-breadcrumb>
  </div>
  <div class="cont_body">
    <div class="list_cont">
      <div class="list_img">
        <img v-if="showType == 'Copyright'" :src="getImg(optionsData.knowledgeCopyright.icon)" alt="">
        <img v-if="showType == 'Patent'" :src="getImg(optionsData.knowledgePatent.icon)" alt="">
      </div>
      <div class="list_cont_body">
        <h4 v-if="showType == 'Copyright'">{{optionsData.knowledgeCopyright.copyrightName}}</h4>
        <div class="list_cont_mid">
          <p v-if="showType == 'Copyright'">分类：<dict-render :dict-obj="dictObjs['projectType']"
            :text="optionsData.knowledgeCopyright.copyrightType"></dict-render>万元</p>
            <p v-if="showType == 'Patent'">分类：<dict-render :dict-obj="dictObjs['projectType']"
              :text="optionsData.knowledgePatent.patentCategory"></dict-render>万元</p>
          <!-- <p>投资阶段：成长期</p> -->
          <p v-if="showType == 'Copyright'">适用范围：<dict-render :dict-obj="dictObjs['copyright_scope']"
            :text="optionsData.knowledgeCopyright.copyrightRange"></dict-render></p>
            <p v-if="showType == 'Patent'">
              交易方式：
              <dict-render :dict-obj="dictObjs['tradeMode']"
              :text="optionsData.tradeMode"></dict-render>
            </p>
              <p v-if="showType == 'Patent'">
                有效期：{{ momentFormat(optionsData.knowledgePatent.validityEnd,'YYYY-MM-DD') }}
              </p>
        </div>
        <!-- <div class="list_cont_end">
          <a-tag v-for="(item,key) in optionsData.investmentField.split()" :key="key">
            <dict-render :dict-obj="dictObjs['investmentField']"
          :text="item"></dict-render>
          </a-tag>
        </div> -->
      </div>
      <div class="list_botton">
        <a-button size="large" @click="onAdd" style="width:120px;" >咨询购买</a-button>
      </div>
    </div>
  </div>
  
  <div class="list_bottom">
    <h4 v-if="showType == 'Copyright'">版权简介</h4>
    <h4 v-if="showType == 'Patent'">专利简介</h4>
    <pre v-if="showType == 'Copyright'">
      {{ optionsData.knowledgeCopyright.remark }}
    </pre>
    <pre v-if="showType == 'Patent'">
      {{ optionsData.knowledgePatent.remark }}
    </pre>
  </div>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { dictMixin,formMixin } from "@/mixins";
import {knowledgePropertyTransactionWeb,tradeApi} from "@/api/knowledge";
import {file_service} from "@/api/adminService";
import DictRender from "@/components/other/DictRender";
import { message } from 'ant-design-vue';
export default {
  name: 'investor',
  components: { 
    DictRender
   },
  mixins: [formMixin,dictMixin],
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showType: '',
      dictNames: 'projectType,copyright_scope,tradeMode',
      optionsData:null,
      lists: [],
      visible:false,
      role: null,
      form: {
          projectId: null,
          senderId: null,
          receiverId: null,
          senderContact: null,
          senderContactNumber: null,
          notes: null,
          processingState: null,
      },
      rules: {
          projectId: [dataCheck.required({})],
          senderId: [],
          receiverId: [],
          senderContact: [dataCheck.required({})],
          senderContactNumber: [dataCheck.required({})],
          processingState: [dataCheck.required({})],
          notes: [],
      },
    }
  },
  computed: {
      submitUrl() {
          return tradeApi.zxsaveOrUpdate
      }
  },
  
  created(){
    if(this.$route.query.queryData){
      this.getAction({
          url: knowledgePropertyTransactionWeb.detail,
          params: {
            id:this.$route.query.queryData
          }
      }).then(res => {
        if(res.knowledgeCopyright){
          this.showType = 'Copyright'
          this.optionsData = res
        }else if(res.knowledgePatent){
          this.showType = 'Patent'
          this.optionsData = res
        }
        this.form.receiverId = res.id
        this.form.senderId = this.$ls.get('notificationId')
        this.role = this.$ls.get('roleCode').split(',')
        this.role.map( item => {
          if(item=='company'){
          this.role = item
          }
        })
      })
     
      
    }
  },
	methods: {
    getProject() {
      this.postAction({
          url: tradeApi.zxsaveOrUpdate,
          params: {
            transactionId:this.optionsData.id
          }
      }).then(
        message.success('交易对接成功')
      )
    },
    onAdd() {
            if(this.$ls.get('token')){
              this.visible=true;
              this.getProject()
            }else{
              message.success("登录后可以操作");
this.$router.push({ path: '/login', query: { id: 'user' } })
            }
    },
    handleOk(){
            this.visible = false;
    },
    getImg(imgUrl) {
        return file_service.imagesWeb(imgUrl)
    },
		goMore(url) {
			this.$router.push(url)
		},
		backhome() {
      this.goMore('/finance/index')
      // location.reload()
		}
	}
}
</script>
<style scoped lang="less">
@import "../../../css/components.less";
:deep(.ant-tag){
  background: #e4e6fc;
  border-radius: 2px;
  border:none;
  padding:2px 10px;
}
.list_cont{
  width: 100%;
  padding:20px 0;
  margin-bottom: 16px;
  &:hover{
    cursor: auto!important;
    box-shadow: none!important;
  }
  .list_img{
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
    border:1px solid #eeeeee;
    margin:20px 10px 20px 25px;
    display: flex;
    align-items: center;
    img{
      width: 100%;
    }
  }
  .list_cont_body{
    flex: 6;
    h4{
      line-height: 50px;
    }
    .list_cont_mid{
      overflow: auto;
      padding-right:30%;
      color:#9c9c9c;
    }
    .list_cont_end{
      margin-top: 20px;
      clear: both;
    }
  }
  .list_botton{
    flex: 1;
    :deep(.ant-btn){
      background: #1890ff;
      color:#fff
    }
  }
}
.list_bottom{
  h4{
    color:#1890ff;
    font-weight: 600;
    font-size: 22px;
    margin-bottom: 10px;
  }
  p{
    line-height: 25px;
  }
}
</style>